module.exports = __webpack_public_path__ + "static/media/blogHeader.a5632b32.png";